import React from 'react'
import { InView } from 'react-intersection-observer'
import { blockInviewHandler } from '../../../../../utils/inview'
import { TextBlock } from '../blocksState'

export const TextBlockLayout = (props: TextBlock) => (
  <InView
    as="section"
    threshold={0}
    triggerOnce={true}
    onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
    className="block block--text block--wysiwyg"
  >
    <div className="block__inner container--m gutter--m">
      <div className="block__content text--styled">
        {props.title && <h2>{props.title}</h2>}
        <div
          className="block__text"
          dangerouslySetInnerHTML={{ __html: props.text }}
        />
      </div>
    </div>
  </InView>
)
